export default __webpack_public_path__ + "static/media/IMG_1358.63775dea.63775dea.JPG";